<template>
  <MenuComponent modulo="embargos"/>
  <main class="main-container items-center w-full px-4 py-4 mx-auto my-10 bg-white rounded-lg shadow-md sm:w-11/12">
    <form class="w-full" @submit.prevent="actualizarPerfil()">
      <div class="bg-white px-4 py-5 sm:p-6">
        <div class="flex flex-wrap justify-center sm:justify-between w-full gap-3 sm:gap-0 py-5 items-center">
          <div class="text-xl font-bold">Perfil</div>
          <router-link to="/inicio" class="w-full sm:w-auto">
            <button
                class="px-4 py-2 text-white bg-green-500 mt-3 w-full sm:mt-0 rounded-md hover:bg-green-600 focus:outline-none">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3"/>
              </svg>
              <span class="ml-3">Volver</span>
            </button>
          </router-link>
        </div>

        <div class="grid grid-cols-6 gap-6">
          <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="nombre_completo" class="block text-sm font-medium text-gray-700">Nombre completo</label>
            <input type="text" id="nombre_completo"
                   class="mt-1 block w-full rounded-md border-gray-200 shadow-sm sm:text-sm"
                   v-model="nombre_completo" required/>
            <ul class="space-y-1 text-red-500 list-inside dark:text-red-400" v-if="!nombreCompletoValido">
              <li class="flex items-center">
                <svg class="w-4 h-4 mr-1.5 text-red-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"
                     xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                        clip-rule="evenodd"></path>
                </svg>
                <span>No se permiten números ni carácteres especiales</span>
              </li>
            </ul>
          </div>
          <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="usuario" class="block text-sm font-medium text-gray-700">Usuario</label>
            <input disabled type="text" id="usuario"
                   class="bg-gray-50 text-gray-400 mt-1 block w-full rounded-md border-gray-200 shadow-sm sm:text-sm"
                   v-model="usuario"/>
          </div>
          <div class="col-span-6 sm:col-span-3 lg:col-span-2">
            <label for="email" class="block text-sm font-medium text-gray-700">Correo electrónico</label>
            <input disabled type="email" id="email"
                   class="bg-gray-50 text-gray-400 mt-1 block w-full rounded-md border-gray-200 shadow-sm sm:text-sm"
                   v-model="email"/>
          </div>
        </div>
        <p class="mt-3 text-lg">
          <span class="font-semibold text-gray-700 mr-3">Rol asignado:</span>
        </p>
        <span v-text="rol.nombre"></span>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 grid grid-cols-6 gap-6">
        <div class="col-span-6 lg:col-span-2 sm:col-span-3">
          <button @click="enviarCorreoContrasena()" type="button"
                  class="w-full lg:w-2/3 sm:w-full rounded-md border border-transparent bg-yellow-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Cambiar contraseña
          </button>
        </div>
        <div class="col-span-6 lg:col-start-5 lg:col-span-2 sm:col-span-3 text-right">
          <button type="submit"
                  class="w-full lg:w-2/3 sm:w-full rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Guardar cambios
          </button>
        </div>
      </div>
    </form>
  </main>
</template>

<script setup>
import {ref} from "vue";
import {swal} from "@/common/constants/variables";
import {generateTextError, useAPIRest, verifyHttpCode} from "@/common/constants";
import {useAuth} from "@/components/auth/store/composables";

const data = JSON.parse(localStorage.getItem("user"));
const authToken = ref(useAuth().authToken);
const nombre_completo = ref(data.nombre_completo);
const usuario = ref(data.usuario);
const rol = ref(data.rol);
const email = ref(data.email);
const nombreCompletoValido = ref(true);
const actualizarPerfil = async () => {
  return await useAPIRest(
      process.env.VUE_APP_NEST_PERFIL_UPDATE.replace(":id", data.id), 'PATCH', authToken.value,
      {nombre_completo: nombre_completo.value}
  ).then((respuesta) => {
    const {statusCode} = respuesta;
    if (verifyHttpCode(statusCode, 'error')) nombreCompletoValido.value = false;
    else {
      nombreCompletoValido.value = true;
      swal.fire(
          "Cambios guardados",
          "Los datos del perfil han sido actualizados",
          "success"
      );
    }
  });
};

const enviarCorreoContrasena = async () => await swal.fire({
  title: '¿Esta seguro de cambiar la contraseña?',
  text: 'Se enviará un enlace de verificación de cambio de contraseña a su bandeja de entrada',
  icon: 'warning',
  showCloseButton: true,
  showCancelButton: true,
  focusConfirm: false,
  confirmButtonText: 'Envíar enlace de verificación',
  cancelButtonText: 'Cancelar',
  showLoaderOnConfirm: true,
  preConfirm: async () => await useAPIRest(process.env.VUE_APP_NEST_AUTH_REMEMBER, 'POST', authToken.value, {email: data.email}, undefined, 'application/json', 'include'),
  allowOutsideClick: () => !swal.isLoading()
}).then(async result => {
  if (result.isConfirmed && result.value !== true) {
    const resJSON = result.value;
    const {statusCode} = resJSON;
    delete resJSON['statusCode'];
    const textoError = generateTextError(resJSON);
    if (verifyHttpCode(statusCode, 'success')) await swal.fire(
        "¡Enlace de verificación enviado!",
        '',
        "success"
    );
    else await swal.fire(textoError, '', 'error');
  }
});
</script>

<script>
import MenuComponent from "@/layouts/MenuComponent";

export default {
  name: "MenuPerfil",
  components: {MenuComponent}
};
</script>
